module.exports = __webpack_public_path__ + "static/media/BG2.5f7c7a92.png";